import React, { ReactNode } from "react";
import { Typography, TypographyProps } from "@mui/material";

type WcTypographyProps = TypographyProps & {
  children?: ReactNode;
};

export const WcTypography = (props: WcTypographyProps) => <Typography {...props} />;

export default WcTypography;
